import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';

import { useLocation, useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import pf_empty from '../../../assets/images/pf_empty.svg';
// import { HeartIcon, CheckIcon } from '@heroicons/react/24/outline';
import defaultProjectPlaceHolder from '../../../assets/images/project_placeholder@2x.jpg';
import {
  fromRole,
  getSbStatusColorString,
  getSbStatusStringWithCounts,
  getStorageNotification,
  isExpired,
  OptionProps,
  saveStorageNotification,
  SbCurrentUser,
  SbStatusMaster,
  SbStatusMasterKeyValueSelect,
  SubmissionBoardFilter,
  SubmissionBoardModel,
} from './component/SbModel';
import CustomDialog from '../shared/Dialog';
import submissionBoardService from '../services/SubmissionBoardService';
import SelectCombobox from './component/SelectCombobox';
import SbDetailsListItemPerf from './performer/SbDetailsListItemPerf';
import {
  FunnelXIcon,
  InfoIcon,
  ListFilterIcon,
  RefreshCcwIcon,
  SearchIcon,
  SlidersHorizontalIcon,
  XIcon,
  MessageCircleWarning,
  PartyPopper
} from 'lucide-react';
import Button from './component/Button';
import { Dialog as HeadlessDialog, Menu, Transition } from '@headlessui/react';
import SelectList from './component/SelectList';
export interface SubmissionBoardsPerformerProps {
  currentUser: SbCurrentUser;
  fromPage: string;
}
export default function SubmissionBoardsPerformer({
  currentUser,
  fromPage,
}: SubmissionBoardsPerformerProps) {
  // const location = useLocation();
  const [pidSid, setPidSid] = useState({
    project_uuid: '',
    submission_board_id: ''
  });
  
  const [records, setRecords] = useState<SubmissionBoardModel[]>([]);
  const [mySbCount, setMySbCount] = useState<number>(0);
  const [hasEverLoadedData, setHasEverLoadedData] = useState<boolean>(false);
  
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [sortMode, setSortMode] = useState<string>('newest');
  
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  // const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 10; // Number of records to fetch per page

  const [submissionBoardFilter, setSubmissionBoardFilter] = useState<SubmissionBoardFilter>({
    keyword: '',
    sb_status: SbStatusMaster.pending_review,
  });
  const [sbStatusFilter, setSbStatusFilter] = useState<OptionProps>({
    id: SbStatusMaster.pending_review,
    name: 'Selection Mode',
  });

  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbClosed, setIsSbClosed] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

 
  const [showGuideCard, setShowGuideCard] = useState(
    getStorageNotification('sb_talent') == 1 ? true : false
  );
  const [profilesSubmissionBoard, setProfilesSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);

  const togglePanel = (index: number) => {
    // If the clicked panel is already open, close it. Otherwise, open the new one.
    setOpenIndex(openIndex === index ? null : index);
  };
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const is_xs_res = useMedia('(min-width: 1px) and (max-width: 639px)', false);
  const today = new Date();
  today.setDate(today.getDate() + 14);
  // Function to get status string with counts

  const getUrlFilter = () => {
    if (typeof window === 'undefined') return {
      project_uuid: '',submission_board_id:''
    };
    const searchParams = new URLSearchParams(window.location.search);
    const project_uuid = searchParams.get('pid') || '';
    const submission_board_id = searchParams.get('sid') || '';
    
    return { project_uuid: project_uuid,submission_board_id:submission_board_id };
  };
    // const newPath = `/submission_boards`;
    const updateUrl = useCallback((newPath) => {
      if (typeof window !== 'undefined' && window.history.pushState) {
        const newUrl = `${window.location.origin}${newPath}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
    }, []);
    
  

  const loadMore = async (from: string) => {
    if (isLoading) {
      console.log('sb: loadMore isLoading is true from ' + from);
      return;
    }
    console.log('sb: set isLoading to true, isLoading was false from ' + from);
    setIsLoading(true);
  };
  useEffect(() => {
    if (isLoading) {
      console.log('sb::useEffect[isLoading] call fetchSubmissionBoardsPerformer page: ' + page);
      const load = async () => {
        await fetchSubmissionBoardsForPerformer(page);
      };
      load();
    }
  }, [isLoading]);

  const refreshRecordList = () => {
    setOpenMenu(false);
    setNoMoreData('');
    setPage(1);
    setOpenIndex(null);
    setRecords([]);
    setSelectedSubmissionBoard(null);
    loadMore('refresh');
  }
  // Load first page
  useEffect(() => {
    console.log('sb::useEffect sortMode');
    refreshRecordList();
  }, [sortMode]);

  // Auto-fill screen after render
  // useEffect(() => {
  //   const checkIfMoreNeeded = () => {
  //     const listBottom = listRef.current?.getBoundingClientRect().bottom || 0;
  //     // console.log('sb::winodws listBottom', listBottom, window.innerHeight);
  //     if (listBottom < window.innerHeight) {
  //       console.log('sb::winodw height more: call loadmore');
  //       loadMore('checkIfMoreNeeded');
  //     }
  //   };

  //   checkIfMoreNeeded();
  //   window.addEventListener('resize', checkIfMoreNeeded);

  //   return () => window.removeEventListener('resize', checkIfMoreNeeded);
  // }, [records]);

  // Infinite scroll on reaching bottom
  useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          console.log('sb::intersect:observerRef loadmore');
          loadMore('[lastelementvisible]');
        }
      }, {
          rootMargin: '0px 0px 10px 0px', 
          threshold: 0
      });
  
      if (observerRef.current) {
        console.log('observerRef start observerRef')
        observer.observe(observerRef.current);
      } else {
        console.log('no observerRef')
      }
  
      return () => {
        console.log('observerRef disconnect')
        observer.disconnect()
      };
    }, [observerRef.current, records]);

  const fetchSubmissionBoardsForPerformer = async (pageParam: number) => {
    try {
      if (noMoreData.length > 0 && pageParam != 0) {
        console.log('fetchSubmissionBoardsPerformer no more data is set');
        return;
      }
      console.log('sb: fetchSubmissionBoardsPerformer In');
      if (records.length <= 0) {
        pageParam = 1;
      }
      let sb_status = '';
      if (submissionBoardFilter && submissionBoardFilter.sb_status != 'All') {
        sb_status = submissionBoardFilter.sb_status;
      }
      const queryParams = getUrlFilter();
      if(queryParams.project_uuid != '') {
        updateUrl('/submission_boards')
        setPidSid(queryParams);
      }

      const data = await submissionBoardService.getSubmissionBoardsForPerformer(
        pageParam,
        perPage,
        submissionBoardFilter && submissionBoardFilter.keyword
          ? submissionBoardFilter.keyword.trim()
          : '',
        sb_status,
        sortMode,
        queryParams.project_uuid,
        queryParams.submission_board_id
      );

      const submission_boards = data.submission_boards;

     if (pageParam === 1) {
        if (submission_boards?.length > 0) {
          setMySbCount(submission_boards.length); 
          setHasEverLoadedData(true);
          if (getStorageNotification('sb_talent') == 1) {
            setShowGuideCard(true);
          }
        } else if (!hasEverLoadedData) {
          setMySbCount(0);
        }
      }

      if (submission_boards && submission_boards.length > 0) {
        if (submission_boards.length < perPage) {
          setNoMoreData('No more profiles...');
        } else {
          setNoMoreData('');
        }
        if(queryParams.project_uuid != '') {
            togglePanel(0);
            setSelectedSubmissionBoard(submission_boards[0]);
        }
        console.log('sb: fetchSubmissionBoardsPerformer page:', page);
        setPage((prev) => prev + 1);
        setRecords((prevRecords) => [...prevRecords, ...submission_boards]);
        return;
      }
       if (pageParam === 1) {
        setNoMoreData('No more profiles...');
      } else {
        setNoMoreData('No matching profiles...');
      }
    } catch (error) {
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
      console.log('sb: fetchSubmissionBoardsPerformer Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };

  const handleSearchClicked = () => {};

  const refreshClicked = async (event?: React.MouseEvent | React.KeyboardEvent) => {
    refreshRecordList();
  };


  const clearFilterClicked = () => {
    setSbStatusFilter({
      id: 'All',
      name: 'All',
    });
    setSubmissionBoardFilter({ keyword: '', sb_status: SbStatusMaster.pending_review });
    setRecords([]);
    setNoMoreData('');
    setPage(1);
    setOpenIndex(null);
    loadMore('[]');
  };

  const handleUnfulfilledRequestsCountChange = useCallback((submissionBoardId: number, count: number) => {
    setRecords((prev) =>
      prev.map((sb) =>
        sb.id === submissionBoardId
          ? {
              ...sb,
              request: count,
            }
          : sb
      )
    );
  }, []);

  const isNewSubmission = (sbCreatedAt: string) => {
    if (!sbCreatedAt) return false;
    
    const createdDate = new Date(sbCreatedAt);
    const now = new Date();
    const diffInHours = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60);
    
    return diffInHours < 24;
  };

  // Skeleton loader component for submission boards
  const SubmissionBoardSkeleton = () => (
    <div className="border rounded-md border-gray-200 bg-white">
      <div className="gap-4 flex flex-col sm:flex-row rounded-md justify-between items-center w-full p-4 sm:py-3 sm:px-6 bg-white shadow-sm">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex items-center gap-2 flex-1">
            {/* Image skeleton */}
            <div className="rounded-lg w-9 h-9 bg-gray-300 animate-pulse"></div>
            {/* Title skeleton */}
            <div className="h-5 bg-gray-300 rounded animate-pulse w-48 sm:w-64"></div>
          </div>
          <div className="flex items-center gap-2">
            {/* Status chip skeleton */}
            <div className="hidden sm:flex h-7 w-24 bg-gray-300 rounded-full animate-pulse"></div>
            {/* Arrow skeleton */}
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
        {/* Mobile status skeleton */}
        <div className="flex sm:hidden px-5 py-4 flex-row justify-center border border-gray-200 items-center w-full rounded-lg bg-gray-50">
          <div className="h-7 w-28 bg-gray-300 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );

  const showGuideUi = () => {
    return (
      <>
         {showGuideCard && (              
              <div className="w-full p-5 bg-blue-100 text-blue-800 font-semibold rounded-lg relative gap-4 flex flex-col mb-6">
                {/* Close Button */}
                <div
                  id="sb_notification_help_id"
                  className="absolute  top-2 right-2 cursor-pointer  w-5 h-5  flex items-center justify-center"
                  onClick={() => {
                    setShowGuideCard(false);
                    saveStorageNotification('sb_talent', 0);
                  }}
                >
                  <XIcon className="h-5 w-5" aria-hidden="true" />
                </div>

                {/* Main Title */}
                <div className="flex flex-col space-y-2 pl-1  text-base font-normal">
                  <div className="flex items-top gap-3">
                    <div className="h-6 w-5 px-1 flex items-center justify-center">
                      <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                        •
                      </div>
                    </div>
                    <div className="m-0" style={{ margin: 0 }}>
                      <span className="font-medium">Review Submission:</span> View the role details of the project-specific submission
                    </div>
                  </div>
                  <div className="flex items-top gap-3">
                    <div className="h-6 w-5 px-1 flex items-center justify-center">
                      <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                        •
                      </div>
                    </div>
                    <div className="m-0" style={{ margin: 0 }}>
                      <span className="font-medium">Customize Kit:</span> update photos or media for this project submission only.
                    </div>
                  </div>
                  <div className="flex items-top gap-3">
                    <div className="h-6 w-5 px-1 flex items-center justify-center">
                      <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                        •
                      </div>
                    </div>
                    <div className="m-0" style={{ margin: 0 }}>
                      <span className="font-medium">Current Photos:</span> Make sure your photos reflect your current look or role.
                    </div>
                  </div>
                  <div className="flex items-top gap-3">
                    <div className="h-6 w-5 px-1 flex items-center justify-center">
                      <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                        •
                      </div>
                    </div>
                    <div className="m-0" style={{ margin: 0 }}>
                      <span className="font-medium">Media:</span> Pro users may upload reels. Upload a self-tape only if requested by the coordinator.
                    </div>
                  </div>
                  <div className="flex items-top gap-3">
                    <div className="h-6 w-5 px-1 flex items-center justify-center">
                      <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                        •
                      </div>
                    </div>
                    <div className="m-0" style={{ margin: 0 }}>
                      <span className="font-medium">Reminder:</span> Updates to your default kit affect all active submissions; updates here apply only to this project.
                    </div>
                  </div>
                </div>
              </div>
            )}
      </>
    );
  }
      const getMenuItemsSorter = () => {
      const menuItems:OptionProps[] = 
        [
        {name:'Newest First', id: 'newest'} ,
        {name:'Oldest First', id: 'oldest'} ,
        {name:'Expiring First', id: 'expiring_first'} ,
        {name:'Expiring Last', id: 'expiring_last'} ,
        {name:'Name (A-Z)', id: 'name_az'} ,
        ];
      return (
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button
            id="layout_sort_id"
            className={`flex items-center justify-center rounded-md px-4 py-2 gap-x-2.5 flex-row border border-gray-300 bg-white box-shadow-100 text-sm font-semibold text-gray-600 hover:text-black`}
          >
            <div className="w-6 h-6 p-3px flex items-center justify-center">
              <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
            </div>
          </Menu.Button>

          <Menu.Items className="absolute right-2 mt-2 w-48 origin-top-right focus:outline-none z-10">
            <div
              className="absolute right-0 text-gray-300 text-center items-center flex w-4 h-4"
              style={{
                zIndex: 51,
                top: '-10px',
                right: '30px',
                width: '1rem',
              }}
            >
              <div
                className="absolute right-1/2 -translate-x-1/2 -top-[1px] w-4 h-4 border-t-2 border-l-2 border-gray-300 transform rotate-45 bg-white"
                style={{
                  zIndex: 51,
                  top: '2px',
                  left: '1.5rem',
                }}
              />
            </div>

            <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
              {menuItems.map((item:OptionProps, index:number) => {
                return (
                  <>
                    <Menu.Item key={index}>
                      {({ active }) => (
                        <div
                          className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                          onClick={(event: React.MouseEvent) => {
                            // event.preventDefault();
                            let newMode = '';
                            if (typeof item.id === 'number') {
                              newMode = item.id.toString();
                            } else {
                              newMode = item.id;
                            }
                            console.log('newMode', newMode, 'sortMode', sortMode);
                            if (sortMode != newMode) {
                              setSortMode(newMode);
                            }
                          }}
                        >
                          <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                            {item.name}
                          </div>
                        </div>
                      )}
                    </Menu.Item>
                  </>
                );
              })}
            </div>
          </Menu.Items>
        </Menu>
      );
    };

  return (
    <div className="w-full flex flex-col flex-1 mx-auto bg-gray-50">
      <div className="w-full flex flex-1 mx-auto px-1 sm:px-6 lg:px-8 pt-10 pb-10">
        {/* mobile filters */}

        <Transition.Root show={openMenu} as={Fragment}>
          <HeadlessDialog
            as="div"
            className="relative z-40"
            onClose={() => {
              setOpenMenu(false);
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <HeadlessDialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                  <div className="flex items-center justify-between px-4">
                    <h2 className="text-lg font-medium text-gray-900">Filters</h2>
                    <button
                      type="button"
                      className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                      onClick={() => setOpenMenu(false)}
                    >
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  <div className="mt-4">
                    <div className="flex sm:hidden flex-col gap-4 px-2">
                      <div className="flex items-center gap-2">
                        <label
                          htmlFor="sb_status_id"
                          className="text-sm font-medium text-gray-700 whitespace-nowrap"
                        >
                          Show:
                        </label>
                        <div className="flex items-center w-full" style={{
                        minWidth: '10rem'
                      }}>
                          <SelectList
                            disabled={mySbCount <= 0}
                            id="sb_status_id"
                            options={SbStatusMasterKeyValueSelect}
                            initialValue={sbStatusFilter}
                            onChange={function (value: OptionProps): void {
                              setSbStatusFilter(value);
                              setSubmissionBoardFilter({
                                ...submissionBoardFilter,
                                ['sb_status']: String(value.id),
                              });
                            }}
                          ></SelectList>
                        </div>
                      </div>
                      <div className="flex items-center justify-center">
                        <Button
                          id="search_sb_btn_id"
                          variant="primary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={refreshClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <SearchIcon className="w-4 h-4" />
                          </div>
                          <div className="flex">Search</div>
                        </Button>
                      </div>
                      <div className="flex items-center justify-center">
                        <Button
                          id="clear_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={clearFilterClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <FunnelXIcon className="w-4 h-4" />
                          </div>
                          Clear All Filters
                        </Button>
                      </div>
                    </div>
                  </div>
                </HeadlessDialog.Panel>
              </Transition.Child>
            </div>
          </HeadlessDialog>
        </Transition.Root>
        {/* mobile filters */}

        <div className="w-full max-w-6xl mx-auto">
          <div className="flex w-full items-center justify-between">
            <div className="flex items-start sm:items-center gap-1">
               <span className="text-2xl sm:text-3xl font-medium text-gray-900">
                Submission Boards
              </span>

              {!showGuideCard && (
                <div
                  id="sb_notification_help_id"
                   className="flex items-center justify-center w-4 h-8 rounded-full text-blue-600 hover:text-blue-800 cursor-pointer transition-colors duration-200 ml-1 mt-0.5 sm:mt-0"
                  onClick={() => {
                    setShowGuideCard(true);
                    saveStorageNotification('sb_talent', 1);
                  }}
                >
                  <InfoIcon className="w-4-2 h-4-2 opacity-100" strokeWidth={1.5} />
                </div>
              )}
            </div>
          </div>
          {/* <hr className="mt-4 mb-4" /> */}
          <div className="flex flex-col relative w-full pt-4">
            {/* top filter bar start */}
            <div className="flex flex-row w-full pb-4 justify-between items-center">
              <div className="flex pr-2 sm:pr-0 flex-row w-full  gap-2  justify-between items-center border-t border-b border-gray-200">
                <div className="flex py-6 flex-row relative items-center gap-2">
                  <div className="flex flex-col gap-1">
                    <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      className="rounded-md border border-gray-300 px-2.5 py-2 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      style={{
                        maxWidth: is_xs_res?'11.25rem':'none'
                      }}
                      placeholder="Search by keyword"
                      disabled={mySbCount <= 0}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setSubmissionBoardFilter({
                          ...submissionBoardFilter,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                          refreshClicked();
                        }
                      }}
                      value={submissionBoardFilter?.keyword || ''}
                    />
                  </div>
                  <div className="border-b hidden sm:flex flex-col gap-1">
                    <div className="flex items-center gap-2">
                      <label
                        htmlFor="sb_status_id"
                        className="text-sm font-medium text-gray-700 whitespace-nowrap"
                      >
                        Show:
                      </label>
                      <div className="flex items-center">
                        <SelectCombobox
                          disabled={mySbCount <= 0}
                          id="sb_status_id"
                          options={SbStatusMasterKeyValueSelect}
                          initialValue={sbStatusFilter}
                          onChange={function (value: OptionProps): void {
                            setSbStatusFilter(value);
                            setSubmissionBoardFilter({
                              ...submissionBoardFilter,
                              ['sb_status']: String(value.id),
                            });
                          }}
                        ></SelectCombobox>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="flex sm:hidden bg-white border rounded-md py-2.5 px-3.5 gap-3 justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                    onClick={() => {
                      setOpenMenu(true);
                    }}
                  >
                    <SlidersHorizontalIcon className="w-6 h-6" />
                  </button>
                  <div className="flex">
                    <Button
                      id="search_sb_btn_id"
                      variant="primary"
                      btn_size="small"
                      className="cursor-pointer"
                      onClick={refreshClicked}
                      disabled={mySbCount <= 0}
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <SearchIcon className="w-4 h-4" />
                      </div>
                      <div className="hidden sm:flex">Search</div>
                    </Button>
                  </div>
                </div>
                {/* <div
                  className="border border-gray-200"
                  style={{
                    width: '1px',
                    height: '-webkit-fill-available',
                    // maxHeight: '2.625rem',
                  }}
                ></div> */}
                <div className="relative flex items-center justify-end gap-2">
                  <div className="relative py-6 hidden sm:flex items-center">
                    <div className="flex items-center gap-2">
                      <div className="flex">
                        <Button
                          id="clear_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={clearFilterClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <FunnelXIcon className="w-4 h-4" />
                          </div>
                          Clear All Filters
                        </Button>
                      </div>
                      {mySbCount > 0 && (
                        <Button
                          id="refresh_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={refreshClicked}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <RefreshCcwIcon className="w-5 h-5" aria-hidden="true" />
                          </div>
                        </Button>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-center border-l border-gray-200 pl-2">
                    <div className="flex py-6 items-center justify-center">
                      {getMenuItemsSorter()}
                    </div>
                  </div>
                </div>

              </div>
            </div>
            {/* top filter bar end */}
            {/* <hr className="mt-4 mb-4" /> */}

            {/* Guide Card */}
            {showGuideCard && (
              <div className="flex">{showGuideUi()}</div>
            )}

            <div className="flex flex-col w-full">
               {!hasEverLoadedData && mySbCount <= 0 && !isLoading && (
                <div className="flex flex-col w-full h-full items-center justify-center gap-2.5 p-15">
                 <p className="font-sans font-semibold text-2xl leading-none tracking-normal text-gray-900 text-center">                    
                    You are not attached to any Submission Boards at this time.
                  </p>
                  <div className="w-full">
                    <img
                      className="ml-auto mr-auto w-96 h-full object-cover"
                      src={pf_empty}
                      alt=""
                    />
                  </div>
                </div>
              )}
             {(hasEverLoadedData || mySbCount > 0) && (
                <div className="mt-1 flex w-full flex-col">
                  <div className="flex w-full flex-col py-2">
                    {/* <%# SB start %> */}
                    <div
                      id="sb_list_id"
                      // ref={listRef}
                      className={
                        (is400_639Screen ? 'px-0' : 'p-0') + ' flex w-full flex-col  gap-6'
                      }
                    >
                      {records.map((item, index) => {
                        const isOpen = openIndex === index;
                        const contentId = `accordion-content-${index}`;
                        const headerId = `accordion-header-${index}`;

                        return (
                          <div
                            key={index}
                            className={`border rounded-md ${
                              isOpen ? 'border-gray-200 ' : 'border-gray-200'
                            }
                            `}
                          >
                            {/* accordian title bar start */}
                            <button
                              id={headerId}
                              type="button"
                              className={`gap-4 flex flex-col sm:flex-row rounded-md justify-between items-center w-full p-4 sm:py-3 sm:px-6 font-semibold text-left transition-colors duration-200
                              ${isOpen ? 'bg-white shadow-sm ' : 'bg-white shadow-sm '}
                              `}
                              onClick={async () => {
                                if (openIndex === index) {
                                  togglePanel(index);
                                  setSelectedSubmissionBoard(null);
                                  return;
                                }
                                togglePanel(index);
                                setSelectedSubmissionBoard(item);
                              }}
                              aria-expanded={isOpen}
                              aria-controls={contentId}
                            >
                              <div className="flex flex-row items-center justify-between w-full">
                                <div className="flex items-center gap-2">
                                  <img
                                    className="rounded-lg w-9 h-9 object-cover"
                                    src={item.project.project_image_thumb || defaultProjectPlaceHolder}
                                    onError={(e) => { (e.target as HTMLImageElement).src = defaultProjectPlaceHolder; }}
                                  ></img>
                                  {(item.header ? item.header + ' / ' : '') + item.title}
                                </div>
                                 
                                <div className="flex items-center gap-2">
                                   {isNewSubmission(item.sb_profiles[0]?.sb_created_at) && (
                                      <div className="hidden sm:flex items-center gap-1">
                                        <PartyPopper className="w-4 h-4 ml-1 top-0.5" style={{ color: '#9CA3AF' }} />
                                        <div className="text-xs font-semibold leading-none tracking-wide uppercase">
                                          NEW!
                                        </div>
                                      </div>
                                    )}
                                   {item?.request != undefined && item.request > 0 && (
                                      <div className="hidden sm:flex items-center gap-2">

                                      <>
                                        <div className= "hidden sm:flex items-center gap-1">
                                          <MessageCircleWarning className="w-4 h-4" style={{ color: '#FF8400' }} /> 
                                          <div className="text-xs font-semibold leading-none tracking-wide uppercase">
                                            Request!
                                          </div>
                                        </div>
                                      </>
                                      </div>
                                    )}
                                  <div                                 
                                    style={{ lineHeight: '100%', height: '1.65rem' }}
                                    className={
                                      'hidden sm:flex font-medium text-sm h-7 items-center chip ' +
                                      getSbStatusColorString(
                                        isExpired(item.expire_at) ? 'expired' : item.sb_status
                                      )
                                    }
                                  >
                                    {getSbStatusStringWithCounts(item)}
                                  </div>
                                  <svg
                                    className={`
                              w-4 h-4 transform transition-transform duration-200
                              ${isOpen ? 'rotate-180' : 'rotate-0'}
                            `}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 9l-7 7-7-7"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div className="flex sm:hidden px-5 py-4 flex-row justify-center border border-gray-200 items-center w-full rounded-lg bg-gray-50">
                               <div className="flex items-center gap-2">
                                  {isNewSubmission(item.sb_profiles[0]?.sb_created_at) && (
                                    <PartyPopper className="w-4 h-4 ml-1 top-0.5" style={{ color: '#9CA3AF' }} />
                                  )}
                                 {item?.request != undefined && item.request > 0 && (
                                    <MessageCircleWarning
                                      className="w-5 h-5 ml-1 opacity-100 rotate-0"
                                      style={{ color: '#FF8400' }}
                                    />
                                  )}
                                  <div
                                    style={{ lineHeight: '100%', height: '1.65rem' }}
                                    className={
                                      'flex sm:hidden font-medium text-sm h-7 items-center chip ' +
                                      getSbStatusColorString(
                                        isExpired(item.expire_at) ? 'expired' : item.sb_status
                                      )
                                    }
                                  >
                                    {getSbStatusStringWithCounts(item)}
                                  </div>
                                </div>
                              </div>
                            </button>
                            {/* accordian title bar end */}
                            {/* accordian title body start */}
                            {/* {index == 0 && <div
                                className={`
                              transition-all duration-300 ease-in-out
                              max-h opacity-100 pb-4 bg-white`}><PreferredByRecipentDummy /></div>} */}
                            {openIndex != null && openIndex === index && (
                              <div
                                id={contentId}
                                role="region"
                                aria-labelledby={headerId}
                                className={`
                              transition-all duration-300 ease-in-out
                              ${isOpen ? 'max-h opacity-100 pb-4 bg-white' : 'max-h-0 opacity-0'}
                            `}
                              >
                                {selectedSubmissionBoard != null && (
                                  <SbDetailsListItemPerf
                                    fromScreen={fromRole.SB_PERFORMER}
                                    indexRow={index}
                                    currentUser={currentUser}
                                    //  currentUserMedia={currentUserMedia}
                                    project={selectedSubmissionBoard.project}
                                    submissionBoardModel={selectedSubmissionBoard}
                                    onUnfulfilledRequestsCountChange={handleUnfulfilledRequestsCountChange}
                                    dialogCloseHandler={() => {
                                      setSelectedSubmissionBoard(null);
                                    }}
                                    refreshSubmissionBoard={() => {
                                      // fetchSubmissionBoardAllDetails(selectedSubmissionBoard.id);
                                    }}
                                    editSb={function (index: number): void {
                                      // setEditSubmissionBoard(item);
                                    }}
                                  ></SbDetailsListItemPerf>
                                )}
                              </div>
                            )}
                            {/* accordian title body end */}
                          </div>
                        );
                      })}
                    </div>
                    {/* <%# SB end %> */}
                  </div>
                  <div className="w-full py-2 flex flex-col justify-center">
                    {isLoading && (
                      <div className="flex w-full flex-col gap-6">
                        <SubmissionBoardSkeleton />
                        <SubmissionBoardSkeleton />
                        <SubmissionBoardSkeleton />
                      </div>
                    )}
                    {noMoreData.length > 0 && records.length === 0 && !isLoading && (
                      <div className="justify-center items-center flex w-full ">
                        <div className="text-center text-gray-500 text-lg">{noMoreData}</div>
                      </div>
                    )}
                      {noMoreData.length > 0 && records.length > 0 && (
                        <div className="flex flex-row w-full font-bold text-xl justify-center">All Submission Boards Loaded</div>
                      )}
                  </div>
                  <div className="w-full py-2 flex flex-col justify-center">
                    <div className="flex w-full justify-center" ref={observerRef}>
                      {noMoreData.length <= 0 && records.length > 0 && !isLoading && (
                        <Button
                          id="load_more_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="absolute  cursor-pointer"
                          onClick={() => {
                            loadMore('loadMoreButton');
                          }}
                        >
                          <div className="w-6 h-6  flex items-center justify-center">
                            <RefreshCcwIcon className="h-6 w-6" aria-hidden="true" />
                          </div>
                          Load More Submissions
                        </Button>
                      )}
                    </div>
                  </div>

                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
